<template>
  <div class="driversTableWrapper table-responsive">
    <b-table
        class="driversTable"
        responsive
        striped
        hover
        small
        :items="items"
        :fields="fields"
        show-empty
        :tbody-tr-class="rowClass"
        :filter="selectedDriver"
        :filter-function="filterRows"
        @row-clicked="onRowClicked">

    </b-table>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'DriversTableWidget',

  data() {
    return {
      fields: [
        { key: 'title', label: this.$t('DRIVERS_TABLE_NAME_COLUMN') },
        { key: 'value', label: this.$t('DRIVERS_TABLE_SCORE_COLUMN') },
        { key: 'value_', label: this.$t('DRIVERS_TABLE_SCORE_TREND_COLUMN') },
        { key: 'delta', label: this.$t('DELTA_POSTFIX') },
        { key: 'action', label: this.$t('DRIVERS_TABLE_ACTION_COLUMN') }
      ],

      items: [],

      footerRow: [],
    }
  },

  props: {
    widgetData: Object
  },

  computed: {
    ...mapState(['activeStudy', 'activeView', 'selectedDriver']),
    ...mapGetters(['absoluteDrillPath', 'completePath', 'pageByName', 'completePath'])
  },

  created: function () {
    this.$store.commit('selectDriver', 'none')
  },

  methods: {
    requestData(requester) {
      requester.addDriversTableRequest(this.dataCallback, this.widgetData.extname);
    },

    dataCallback(dto) {
      this.items = dto.driverStatsDTO.drivers
    },

    onRowClicked(row) {
      if(!row.drivervar) {
        if(this.selectedDriver === row.driver) {
          this.$store.commit('selectDriver', 'none')
          // this.filter = 'none'
        } else {
          this.$store.commit('selectDriver', row.driver)
          // this.filter = row.driver
        }
      }
    },

    rowClass(item, type) {
      if (!item) return

      if(type==='row') {
        let classes = []
        classes.push( (item.drivervar) ? 'driverVarRow' : 'driverRow' )
        if(item.actionName==='MAINTAIN') {
          classes.push('maintainRow')
        } else if(item.actionName==='PRIORITISE') {
          classes.push('prioRow')
        }

        return classes;
      }

    },

    filterRows(row, filter) {
      if(filter==='none') {
        return row.drivervar===false
      }
      return row.driver===filter || !row.drivervar
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.driversTableWrapper {
  white-space: nowrap;
  padding: 0.5em;
  background-color: white;
}

.driverRow {
  font-weight: bold;
}

driverVarRow {
}

tr.driverVarRow>:nth-child(1){
  padding-left: 1em;
}

tr.prioRow>:nth-child(5){
  color: red;
}

tr.maintainRow>:nth-child(5) {
  color: green;
}

</style>
